import { FlexContainer } from '@pitchero/react-ui';
import { orderBy } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import KeyMoments from './key-moments';
import MatchCommentary from './match-commentary';
import MatchAwards from './match-awards';

const Events = ({ homeOrAway, eventsByPeriod, overview }) => {
  // Show the latest event at the top
  const orderedPeriods = orderBy(eventsByPeriod, ['number'], 'desc').map((period) => ({
    ...period,
    events: orderBy(period.events, ['seconds'], 'desc'),
  }));

  return (
    <FlexContainer flexDirection="column" style={{ gap: '20px' }}>
      <MatchAwards overview={overview} />
      {homeOrAway && <KeyMoments events={orderedPeriods} homeOrAway={homeOrAway} />}
      <MatchCommentary events={orderedPeriods} />
    </FlexContainer>
  );
};

Events.propTypes = {
  homeOrAway: PropTypes.oneOf(['h', 'a']),
  eventsByPeriod: PropTypes.arrayOf(
    PropTypes.shape({
      end: PropTypes.string,
      name: PropTypes.string,
      events: PropTypes.arrayOf(
        PropTypes.shape({
          scoreAdjustment: PropTypes.number.isRequired,
          id: PropTypes.number.isRequired,
          type: PropTypes.string.isRequired,
        }),
      ),
    }),
  ).isRequired,
  overview: PropTypes.shape().isRequired,
};

Events.defaultProps = {
  homeOrAway: null,
};

export default Events;
